import { useEffect, useState } from 'react'
import { router } from 'expo-router'
import { useSharedValue, withTiming } from 'react-native-reanimated'
import { timingConfig } from './styles'

interface Args {
  total: number
}

export default function useNavigateRecommendations({ total }: Args) {
  const [row, setRow] = useState<number>(0)

  const animation = useSharedValue(0)

  const next = () => setRow((v) => Math.min(total, v + 1))
  const prev = () => setRow((v) => Math.max(0, v - 1))

  const handleBack = () => {
    if (row > 0) {
      prev()
      return
    }
    router.back()
  }

  useEffect(() => {
    animation.set(withTiming(row, timingConfig))
  }, [row, animation])

  return {
    row,
    animation,
    next,
    prev,
    handleBack,
  }
}
